var _rect, _mask, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnFlagGb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 9,
    rx: 0.9,
    fill: "#fff"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icn-flag-gb_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 9
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 9,
    rx: 0.9,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icn-flag-gb_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A17A7",
    d: "M0 0h12v9H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-.55-.862l5.121 3.627V-.6H7.43v3.365l5.12-3.627.64.994L9.139 3H12v3H9.14l4.049 2.868-.64.994-5.12-3.627V9.6H4.57V6.236l-5.12 3.626-.64-.994L2.861 6H0V3h2.86L-1.189.132l.64-.994z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2.85L13.43-.9M8.577 6.164l4.866 3.444M3.43 2.84L-1.644-.752M3.981 6.122l-5.626 3.918",
    stroke: "#DB1F35",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.4h5.143V9h1.714V5.4H12V3.6H6.857V0H5.143v3.6H0v1.8z",
    fill: "#E6273E"
  }))));
}
export default SvgIcnFlagGb;